import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

const SITE_NAME = "Viktoria Lipkovska";
const DEFAULT_DESCRIPTION = "Professional photography portfolio and services.";
const DEFAULT_IMAGE = "./img/about/my_photo.jpg";

const SEO = ({
    title,
    description = DEFAULT_DESCRIPTION,
    image = DEFAULT_IMAGE,
    url,
    lang = "en",
    noindex = false,
}) => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    const robots = noindex ? "noindex, nofollow" : "index, follow";

    return (
        <Helmet htmlAttributes={{ lang }}>
            <title>{fullTitle}</title>
            <meta charSet="utf-8" />
            <meta name="description" content={description} />
            <meta name="robots" content={robots} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
            {url && <meta property="og:url" content={url} />}
            <meta property="og:image" content={image} />
            {url && <link rel="canonical" href={url} />}
        </Helmet>
    );
};

SEO.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    url: PropTypes.string,
    lang: PropTypes.string,
    noindex: PropTypes.bool,
};

export default SEO;
